import { memo } from 'react'
import {
  EyeIcon,
  MagnifyingGlassIcon,
  MapIcon,
  TrophyIcon,
  CheckBadgeIcon,
  StarIcon,
  HeartIcon,
  PencilSquareIcon,
} from '@heroicons/react/24/solid'
import { MILESTONES } from '../../config/constants'

const MILESTONE_ICONS = {
  first_sighting:  EyeIcon,
  scout:           MagnifyingGlassIcon,
  tracker:         MapIcon,
  legend:          TrophyIcon,
  first_confirm:   CheckBadgeIcon,
  super_confirmer: StarIcon,
  fan:             HeartIcon,
  reviewer:        PencilSquareIcon,
}

/**
 * MilestoneBadges - Displays earned gamification badges based on user stats
 *
 * @param {Object} props.stats - { totalSightings, totalConfirmations, favoriteCount, totalReviews }
 *
 * @idempotent - Pure display component; same stats always yield same badges
 * @atomic     - Single responsibility: render earned milestone badges
 */
const MilestoneBadges = memo(function MilestoneBadges({ stats }) {
  if (!stats) return null

  const earned = MILESTONES.filter(m => (stats[m.stat] || 0) >= m.threshold)
  if (earned.length === 0) return null

  return (
    <div className="mt-3 mb-1">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Badges earned</p>
      <div className="flex flex-wrap gap-2">
        {earned.map(m => {
          const Icon = MILESTONE_ICONS[m.id]
          return (
            <span
              key={m.id}
              title={`${m.label} — reach ${m.threshold} ${m.stat.replace(/([A-Z])/g, ' $1').toLowerCase()}`}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold border border-primary/20"
            >
              {Icon && <Icon className="h-3.5 w-3.5" />}
              <span>{m.label}</span>
            </span>
          )
        })}
      </div>
    </div>
  )
})

export default MilestoneBadges
